import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';

import {IconWithTooltip} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {ArgosStatus, getArgosStreamStatusChipColor} from '@utils/tableHelpers';

export const StreamStatusLabel = ({liveJob, eventId, jobId}) => {
    const history = useHistory();

    const stream = liveJob?.stream;
    const status = stream?.status;
    const hasStreamHistory = stream?.events && 0 < stream.events.length;

    const handleHistoryClick = (e) => {
        e.stopPropagation();
        history.push(getLink('events.argosJobs.streamHistory', {id: eventId, argosJobId: jobId}));
    };

    const statusLower = status?.toLowerCase();

    return (
        <span className='stream-status-label'>
            {status
                ? <ArgosStatus
                    label={(status || '').replaceAll('_', ' ')}
                    color={getArgosStreamStatusChipColor(statusLower)}
                />
                : <span>-</span>
            }
            {hasStreamHistory && (
                <IconWithTooltip
                    iconProps={{
                        className: 'stream-history-icon outline',
                        onClick: handleHistoryClick,
                        style: {marginLeft: '0.5rem', cursor: 'pointer'},
                    }}
                    name='file alternate outline'
                    tooltip='Stream history'
                />
            )}
        </span>
    );
};

StreamStatusLabel.propTypes = {
    liveJob: PropTypes.shape({
        stream: PropTypes.shape({
            status: PropTypes.string,
            events: PropTypes.array,
        }),
    }),
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default StreamStatusLabel;
